module.exports = __webpack_public_path__ + "static/media/divider.ab69bc1f.svg";